"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordStrengthIndicator = exports.PasswordInput = exports.defaultSettings = void 0;
var antd_1 = require("antd");
var react_1 = __importStar(require("react"));
var tai_password_strength_1 = require("tai-password-strength");
var PASSWORD_STRENGTH = new tai_password_strength_1.PasswordStrength();
var PASSWORD_STRENGTH_CODE = ['VERY_WEAK', 'WEAK', 'REASONABLE', 'STRONG', 'VERY_STRONG'];
exports.defaultSettings = {
    colorScheme: {
        levels: ["#ff4033", "#fe940d", "#ffd908", "#cbe11d", "#6ecc3a"],
        noLevel: "lightgrey"
    },
    height: 3,
    alwaysVisible: false
};
exports.PasswordInput = react_1.default.forwardRef(function (_a, ref) {
    var _b = _a.settings, settings = _b === void 0 ? exports.defaultSettings : _b, onLevelChange = _a.onLevelChange, props = __rest(_a, ["settings", "onLevelChange"]);
    var _c = (0, react_1.useState)(''), input = _c[0], setInput = _c[1];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(antd_1.Input.Password, __assign({}, props, { ref: ref, value: input, onChange: function (e) { var _a; setInput(e.target.value); (_a = props === null || props === void 0 ? void 0 : props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, e); } })),
        react_1.default.createElement(exports.PasswordStrengthIndicator, { input: input, onLevelChange: onLevelChange, settings: settings })));
});
var PasswordStrengthIndicator = function (_a) {
    var input = _a.input, settings = _a.settings, onLevelChange = _a.onLevelChange;
    // Calculate level
    var level = react_1.default.useMemo(function () {
        return input.length == 0 ? -1 : PASSWORD_STRENGTH_CODE.indexOf(PASSWORD_STRENGTH.check(input).strengthCode);
    }, [input]);
    // Calculate indicators
    var indicators = react_1.default.useMemo(function () {
        var ind = [];
        for (var i = 0; i < 5; i++) {
            var color = i <= level
                ? settings.colorScheme.levels[level]
                : settings.colorScheme.noLevel;
            ind.push(react_1.default.createElement("div", { key: "indicator-".concat(i), style: getIndicatorStyle(color, settings.height) }));
        }
        return ind;
    }, [level, settings]);
    (0, react_1.useEffect)(function () {
        onLevelChange === null || onLevelChange === void 0 ? void 0 : onLevelChange(level);
    }, [level]);
    if (!settings.alwaysVisible && level < 0) {
        return null;
    }
    return react_1.default.createElement("div", { style: getWrapperStyle(settings.height) }, indicators);
};
exports.PasswordStrengthIndicator = PasswordStrengthIndicator;
function getWrapperStyle(height) {
    return {
        lineHeight: height + "px"
    };
}
function getIndicatorStyle(color, height) {
    return {
        display: "inline-block",
        width: "20%",
        backgroundColor: color,
        height: height + "px",
        borderRadius: "2px"
    };
}
